import { t } from '@lingui/macro'
import NoRemoteVideo from './NoRemoteVideo'

interface LocalVideoOffProps {
  name?: string
  statusLabel?: string
}

export function LocalVideoOff({ name, statusLabel }: LocalVideoOffProps) {
  return <NoRemoteVideo participantName={name} statusLabel={statusLabel ?? t`Camera off`} isRemotePresent compact />
}

export default LocalVideoOff
